import theme from "../theme";
import { Box, styled, TableCell, tableCellClasses, TableRow } from "@mui/material";
// Select-----------
export const SelectLabel = {

  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    fontSize: "1.1rem",
    fontWeight: "600",
  },
  ' & .MuiInputLabel-outlined.MuiInputLabel-shrink ': {
    transform: 'translate(12px, -10px) scale(0.75)'
  },
  '& fieldset': {
    fontSize: '1.1rem',
  },
};
//-----------------------------dialog styles
export const IconContainer = (colors) => ({
  backgroundColor: theme.colors.primary[50],
  borderRadius: '10px',
  padding: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.colors.primary[800],

});

export const DialogTitleText = (colors) => ({
  fontSize: 20,
  color: theme.colors.primary[900],
  fontFamily: "Akatab",
  fontWeight: "600"
});

export const DialogSection = (colors) => ({
  fontSize: "1.1rem",
  color: colors.grey[500],
  fontFamily: "Akatab",
  mb: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  fontWeight: "bold"
});

export const DialogSectionLabel = (colors) => ({
  fontSize: "0.9rem",
  color: colors.grey[700],
  fontFamily: "Mulish",
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,  // Reduced gap between icon and label
  minWidth: 'auto',  // Remove fixed width to let content determine width
  marginRight: '8px',  // Add small space after label
  fontWeight: "bold"
});
export const DialogSectionValue = (colors) => ({
  fontSize: "0.9rem",
  color: colors.grey[600],
});


// ----------------screen
export const TitleScreen = (colors) => ({
  fontSize: { xs: "1.3rem", sm: "1.4rem", md: "1.5rem", lg: "1.7rem", xl: "1.7rem" },
  color: theme.colors.primary[800],
  fontFamily: "Akatab",
  fontWeight: "700",
});

export const SubTitleScreen = (colors) => ({
  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.1rem", lg: "1.3rem", xl: "1.3rem" },
  color: theme.colors.grey[500],
  fontFamily: "Akatab",
  fontWeight: "300",
  mb: "5px"
});
export const LabelText = (colors) => ({
  fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
  color: theme.colors.grey[700],
  fontFamily: "Mulish",
  fontWeight: "700",
  mb: 1,
});
// ------------textfield
export const FieldLabel = {


  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    fontSize: '1.1rem',
    fontWeight: 600,
    transform: 'translate(12px, -10px) scale(0.75)', // Merged duplicate selectors
  },
  '& fieldset': {
    fontSize: '1.1rem',
  },
};

// ----------- Base button styles
const baseButtonStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.sm,
    fontFamily: theme.typography.fontFamily.sans.join(', '),
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.normal,
    borderRadius: theme.borderRadius.lg,
    border: '2px solid transparent',
    cursor: 'pointer',
    transition: 'all 150ms ease-in-out',
    textDecoration: 'none',
    outline: 'none',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    
    // Size variants
    padding: `${theme.spacing.sm} ${theme.spacing.md}`, // Reduced padding
    minHeight: '2.5rem', // Reduced from 2.75rem
    minWidth: 'fit-content', // Allow buttons to shrink to content
    
    // Focus styles
    ':focusVisible': {
      outline: `2px solid ${theme.colors.primary[500]}`,
      outlineOffset: '2px'
    },
    
    // Disabled styles
    ':disabled': {
      cursor: 'not-allowed',
      opacity: 0.6
    }
  };

// Primary Button Styles
export const PrimaryButton = {
    padding: "5px",
    paddingX: "12px",
    ...baseButtonStyles,
    backgroundColor: theme.colors.primary[500],
    color: theme.colors.text.inverse,
    boxShadow: theme.boxShadow.sm,
    
    ':hover': {
      backgroundColor: theme.colors.primary[600],
      boxShadow: theme.boxShadow.md,
      transform: 'translateY(-1px)'
    },
    
    ':active': {
      backgroundColor: theme.colors.primary[700],
      boxShadow: theme.boxShadow.sm,
      transform: 'translateY(0)'
    },
    
    ':focusVisible': {
      ...baseButtonStyles[':focus-visible'],
      boxShadow: `${theme.boxShadow.md}, 0 0 0 3px ${theme.colors.primary[200]}`
    },
    
    ':disabled': {
      ...baseButtonStyles[':disabled'],
      backgroundColor: theme.colors.gray[300],
      color: theme.colors.gray[500],
      boxShadow: 'none',
      transform: 'none'
    },
    

  };

// Secondary Button Styles
export const SecondaryButton = {
    ...baseButtonStyles,
    paddingX: "12px",
    backgroundColor: theme.colors.primary[100],
    color: theme.colors.primary[500],
    boxShadow: theme.boxShadow.sm,
    
    ':hover': {
      backgroundColor: theme.colors.primary[200],
      boxShadow: theme.boxShadow.md,
      transform: 'translateY(-1px)'
    },
    
    ':active': {
      backgroundColor: theme.colors.primary[700],
      boxShadow: theme.boxShadow.sm,
      transform: 'translateY(0)'
    },
    
    ':focusVisible': {
      ...baseButtonStyles[':focusVisible'],
      outline: `2px solid ${theme.colors.primary[500]}`,
      boxShadow: `${theme.boxShadow.md}, 0 0 0 3px ${theme.colors.primary[200]}`
    },
    
    ':disabled': {
      ...baseButtonStyles[':disabled'],
      backgroundColor: theme.colors.gray[300],
      color: theme.colors.gray[500],
      boxShadow: 'none',
      transform: 'none'
    },
    
  };
  
  // Secondary Outlined Button Styles
  export const SecondaryOutlinedButton = {
    ...baseButtonStyles,
    paddingX: "12px",
    backgroundColor: 'transparent',
    color: theme.colors.primary[600],
    borderColor: theme.colors.primary[400],
    borderWidth: '2px',
    borderStyle: 'solid',
    
    ':hover': {
      backgroundColor: theme.colors.primary[100],
      borderColor: theme.colors.primary[500],
      color: theme.colors.primary[700],
      boxShadow: theme.boxShadow.sm,
      transform: 'translateY(-1px)'
    },
    
    ':active': {
      backgroundColor: theme.colors.primary[200],
      borderColor: theme.colors.primary[600],
      color: theme.colors.primary[800],
      transform: 'translateY(0)'
    },
    
    ':focusVisible': {
      ...baseButtonStyles[':focusVisible'],
      outline: `2px solid ${theme.colors.primary[500]}`,
      boxShadow: `0 0 0 3px ${theme.colors.primary[200]}`
    },
    
    ':disabled': {
      ...baseButtonStyles[':disabled'],
      backgroundColor: 'transparent',
      borderColor: theme.colors.gray[300],
      color: theme.colors.gray[400],
      transform: 'none'
    },
    
  };



  

  //------------------ table style react table
  export const StyledTableCell = styled(TableCell)(({ theme, colors }) => ({

    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      color: colors.grey[700],
    },
    [`&.${tableCellClasses.root}`]: {
      padding: "5px 16px"
    },
  }));
  export const StyledHeadCell = styled(TableCell)(({ theme, colors }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontSize: 16,
      color: colors.primary[500],
      backgroundColor: colors.primary[50],
      fontWeight: "bold",
      fontFamily: "Mulish",
      transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      }
    },
    [`&.${tableCellClasses.root}`]: {
      padding: "12px 16px",
  
    },
  }));
  
  export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
  
    // '&:nth-of-type(odd)': {
    //   backgroundColor: theme.palette.action.hover,
    // },
    // hide last border
    // '&:last-child td, &:last-child th': {
    //   border: 0,
    // },
  }));
  
  export const StyledTableRowHead = styled(TableRow)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.action.hover,
    borderTopLeftRadius: "80px", // Match the radius
    borderTopRightRadius: "80px", // Match the radius
    overflow: "hidden", // Ensures no clipping issues
    
  
  }));
  
  export const StyledSortIcon = styled(Box)(({ theme }) => ({
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors?.secondary?.[300] || '#e2c29c',
    marginLeft: '4px',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
      opacity: 0.5,
    }
  }));